define("shared/utils/hash-code", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   * @extends Utils
   *
   *
   * hashCode is a hash function which encodes a string into a 32-bit integer
   * https://stackoverflow.com/questions/194846/is-there-hash-code-function-accepting-any-object-type
   *
   * @method hashCode
   * @param {String} string The string to encode
   * @returns {Integer} Hashed string as a 32-bit integer
   */
  const hashCode = function () {
    let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return string.split('').reduce((partialHash, char) => {
      const code = char.charCodeAt(0);
      const leftShifted = partialHash << 5;
      const hash = leftShifted - partialHash + code;
      return hash & hash;
    }, 0);
  };
  var _default = _exports.default = hashCode;
});